import { z } from 'zod';

import { captureSentryException } from 'shared/utils';

import { FORGOT_PASSWORD_FEATURE_TAG, VALIDATION_ERROR_CODE } from '../consts';

const ForgotPasswordServerErrorPayloadSchema = z.object({
  fields: z.record(z.string(), z.array(z.nativeEnum(VALIDATION_ERROR_CODE)))
});

/**
 * Extracts the first `{ field, code }` pair from an API validation error payload.
 * Returns `undefined` if the payload isn't a recognizable validation response
 * or has no field errors.
 */
export const getFirstValidationError = (error: unknown) => {
  const result = ForgotPasswordServerErrorPayloadSchema.safeParse(error);

  if (!result.success) {
    captureSentryException({
      message: 'Unrecognised forgot-password validation error',
      feature: FORGOT_PASSWORD_FEATURE_TAG,
      error,
      extra: { method: 'getFirstValidationError', zodErrors: result.error.flatten() }
    });

    return undefined;
  }

  const [entry] = Object.entries(result.data.fields);

  if (!entry) {
    return undefined;
  }

  const [field, codes] = entry;
  const [code] = codes;

  if (!code) {
    return undefined;
  }

  return { field, code };
};
